<template>
  <panel :title="title" :to="{ name: 'feed', params: { identifier: moduleIdentifier, code: feed._id.$oid } }" :withBody="false" :withFooter="false">
    <span slot="header-right" :class="feed.status" class="badge">{{ $t(`${moduleIdentifier}.feed.statuses.${feed.status}.label`) }}</span>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import moment from 'moment'

  export default {
    props: {
      feed: {
        type: Object,
        require: true
      },
      moduleIdentifier: {
        type: String,
        require: true
      }
    },
    computed: {
      title () {
        let externalCode = ''
        if (this.feed.externalCode) {
          externalCode = `(${this.feed.externalCode})`
        }
        return `${this.$t(`${this.moduleIdentifier}.feed.label`)} de <b>${this.$t(`${this.moduleIdentifier}.feed.type.${this.feed.type}.label`).toLowerCase()}</b> ${externalCode} em ${moment(this.feed.created).format('DD/MM/YYYY HH:mm')}`
      }
    },
    components: {
      Panel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Card.vue?2679c7d4